import { PaymentParams, ReceiverParams } from 'app/models/payments-params'
import { getEntities } from 'app/state/ducks/entities/selectors'
import { getReceivers } from 'app/state/ducks/payments/selectors'
import { formatNumberToCurrency } from 'app/utils/util-functions'
import WireInstructionHoverCard from 'app/views/components/popover/wire-instruction-hover-card'
import React from 'react'
import { mapEntityIdsToNames } from 'app/utils/util-functions'
import { useSelector } from 'react-redux'
import { receiverColDefs, ReceiverTableParams } from './receiver-column-defs'
import cleanUUID from 'app/views/components/functions/cleanUUID'
import MainTable from 'app/views/components/Table/MainTable'
import { ReceiversActions } from './receiver-actions'
import { Text, Button } from '@mantine/core'
import { kycStatusOptions } from 'app/models/dropdown-options'
import CustomHoverCard from 'app/views/components/popover/custom-hover-card'
import IonIcon from '@reacticons/ionicons';

interface Props {
  payment: PaymentParams
  closeDrawer: () => void
  isDrawer?: boolean
}


export const ReceiversTable = ({ payment, closeDrawer }: Props) => {
  const entities = useSelector(getEntities)
  const receivers = useSelector(getReceivers)

  function cleanDealData(
    filteredReceivers: ReceiverParams[],
  ): ReceiverTableParams[] {
    const entityIdToName = mapEntityIdsToNames(entities);

    return (
      filteredReceivers.map((lender) => {
        const lenderName = lender.lenderId?.id
          ? entityIdToName.get(cleanUUID(lender.lenderId.id)) ?? ''
          : '';

        const entity = entities.find(entity => entity.id === lender.lenderId.id && entity?.kycStatus !== 'ValidatedStatus');
        const wiMissingText = !lender.wireInstruction ? 'Wire Instruction is missing. ' : '';;
        const alertEntityText = entity ? 'KYC Status needs to be Validated for payment release. ' : '';
        const buttonText = kycStatusOptions.find(option => option.value === entity?.kycStatus)?.label ?? ''
        const alertText = `${wiMissingText} ${alertEntityText}`;

        return {
          lender: lenderName,
          wireInstruction: lender.wireInstruction ? <WireInstructionHoverCard wireInstruction={lender.wireInstruction} /> : <Text style={{ fontSize: "15px" }}>N/A</Text>,
          amount: formatNumberToCurrency(Number(lender.amount), lender.wireInstruction?.currency ?? payment.payment.currency ?? 'USD'),
          alert: entity || !lender.wireInstruction ?
            (
              <CustomHoverCard
                cardTitle='Alert'
                position="left"
                targetComponent={
                  <div>
                    <IonIcon size="large" name="alert-circle-sharp" style={{ color: "red" }} />
                  </div>
                }
              >
                <Text className="hover-card-alert-text">
                  {alertText}
                </Text>
                {entity ?
                  (<div className="hover-card-button-container">
                    <Button
                      className="hover-card-button"
                    >
                      {buttonText}
                    </Button>
                  </div>
                  ) : null}
              </CustomHoverCard>
            ) : null,
          actions: <ReceiversActions lender={lender} closeDrawer={closeDrawer} payment={payment} />,
        };
      })
    );
  }

  return (
    <div style={{ padding: "0px 30px" }}>
      <MainTable
        minHeight={'100px'}
        tableName=''
        withPagination={false}
        csvExportEnabled={false}
        enableTopToolbar={false}
        headerBackgroundColor='#F0EEEE'
        columnDefs={receiverColDefs}
        data={cleanDealData(receivers)}
        setRow={() => null} />
    </div>
  )
}
